export default class SignDisplay {
    constructor(type, path) {
        this.type = type;
        this.path = path;
    }

    get name() {
        return {
            'video': 'Video',
            'photo': 'Photo',
            'la_hend': 'Illustration',
            'image': 'Image',
        }[this.type] || 'not found';
    }

    get iconClass() {
        return {
            'video': 'fa-solid fa-video',
            'image': 'fa-solid fa-image',
            'la_hend': 'fa-solid fa-paintbrush',
            'photo': 'fa-solid fa-apple-whole',
        }[this.type] || 'not found';
    }

    isVideo() {
        return this.type == 'video';
    }

    exists() {
        return !! this.path;
    }
}
